<template>
    <div class="bg-indigo-50 p-5 rounded">
        <div class="font-bold">День</div>
        <div class="mt-2">
            <div class="sm:flex">
                <div v-for="item in days" :key="item.id" @click="toggleDevice(item)">
                    <div :class="[item.checked ? 'border-transparent' : 'border-gray-300', item.active ? 'border-indigo-500 ring-2 ring-indigo-500' : '', 'relative bg-white border rounded-lg shadow-sm p-2 flex cursor-pointer focus:outline-none mt-2 sm:mt-0 sm:mr-2']">
                        <div class="flex-1 flex">
                            <div class="flex">
                                <div class="flex-shrink-0">
                                    <component :is="item.icon" class="'text-gray-400 group-hover:text-gray-500 mr-4 flex-shrink-0 h-6 w-6" aria-hidden="true" />
                                </div>
                                <div class="block text-gray-900">
                                    {{ item.title }}
                                </div>
                            </div>
                            <div :class="[item.active ? 'border' : 'border-2', item.checked ? 'border-indigo-500' : 'border-transparent', 'absolute -inset-px rounded-lg pointer-events-none']" aria-hidden="true" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import rules_dictionary from "@/scripts/store/rules_dictionary";

export default {
    props: {
        initRule: {
            required: true
        },
        modelValue: {
            required: true
        }
    },

    mounted() {
        this.days.forEach(day => day.checked = false)

        if (!this.modelValue.days || this.modelValue.days.length <= 0) {
            return
        }

        this.modelValue.days.forEach(dayId => {
            this.days.find(d => d.id === dayId).checked = true
        })
    },

    data() {
        return {
            days: rules_dictionary.days,
            rule: this.initRule
        }
    },

    methods: {
        toggleDevice(day) {
            day.checked = !day.checked
            const days = this.days.filter(day => day.checked).map(day => day.id)

            if (days.length > 0) {
                this.$emit('update:modelValue', {days: days})
            } else {
                this.$emit('update:modelValue', {})
            }
        }
    }
}
</script>
